import { Autocomplete, Loader } from '@mantine/core';
import { useFocusWithin } from '@mantine/hooks';
import cx from 'clsx';
import { FC, memo } from 'react';
import defaultStyles from 'src/components/Form/styles.default.module.css';
import { useFormContext } from 'src/form';

import styles from './styles.module.css';
import { useEmail } from './use-email';

type Props = {
  name: string;
  label: string;
  placeholder: string;
};

export const InputEmail: FC<Props> = memo((props) => {
  const { ref, focused } = useFocusWithin();
  const { data, loading, value, handleChange } = useEmail();
  const form = useFormContext();

  const { onChange, ...formProps } = form.getInputProps(props.name);

  return (
    <Autocomplete
      classNames={{
        dropdown: styles.dropdown,
        input: defaultStyles.input,
        label: defaultStyles.label,
        option: styles.option,
        root: cx({
          [defaultStyles.root]: true,
          [defaultStyles.rootFocused]: focused,
        }),
      }}
      data={data}
      onChange={(val) => {
        handleChange(val);
        onChange(val);
      }}
      ref={ref}
      rightSection={loading ? <Loader size="1rem" /> : null}
      withAsterisk={false}
      value={value}
      {...props}
      {...formProps}
    />
  );
});
